import { render, staticRenderFns } from "./VotiveStand.vue?vue&type=template&id=6d9530d2&scoped=true&"
import script from "./VotiveStand.vue?vue&type=script&lang=js&"
export * from "./VotiveStand.vue?vue&type=script&lang=js&"
import style0 from "./VotiveStand.vue?vue&type=style&index=0&id=6d9530d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9530d2",
  null
  
)

export default component.exports